import React from "react";

function Others(props) {
  return <h1>Others Page</h1>;
}

export default Others;